export const override = `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
  `;

export const DUMMY_FACILITIES = [
  {
    key: 'facility-1',
    facilityName: "Children's Hospital of Milwaukee",
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-2',
    facilityName: 'Froedtert Hospital',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-3',
    facilityName: 'Town Hall Health Center',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-4',
    facilityName: 'Milwaukee Hospital',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-5',
    facilityName: 'Center for Cardiology',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-6',
    facilityName: 'Fast Clinic at Meijier',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-7',
    facilityName: 'Family Clinic',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-8',
    facilityName: 'Heart Health Center',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-9',
    facilityName: "Children's Hospital of Milwaukee 1",
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-10',
    facilityName: 'Froedtert Hospital 1',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-11',
    facilityName: 'Town Hall Health Center 1',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-12',
    facilityName: 'Milwaukee Hospital 1',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-13',
    facilityName: 'Center for Cardiology 1',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-14',
    facilityName: 'Fast Clinic at Meijier 1',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-15',
    facilityName: 'Family Clinic 1',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-16',
    facilityName: 'Heart Health Center 1',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-17',
    facilityName: "Children's Hospital of Milwaukee 2",
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-18',
    facilityName: 'Froedtert Hospital 2',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-19',
    facilityName: 'Town Hall Health Center 2',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-20',
    facilityName: 'Milwaukee Hospital 2',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-21',
    facilityName: 'Center for Cardiology 2',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-22',
    facilityName: 'Fast Clinic at Meijier 2',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-23',
    facilityName: 'Family Clinic 2',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-24',
    facilityName: 'Heart Health Center 2',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-25',
    facilityName: "Children's Hospital of Milwaukee 3",
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-26',
    facilityName: 'Froedtert Hospital 3',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-27',
    facilityName: 'Town Hall Health Center 3',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-28',
    facilityName: 'Milwaukee Hospital 3',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-29',
    facilityName: 'Center for Cardiology 3',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-30',
    facilityName: 'Fast Clinic at Meijier 3',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-31',
    facilityName: 'Family Clinic 3',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
  {
    key: 'facility-32',
    facilityName: 'Heart Health Center 3',
    facilityAddress: 'AnyStreet Dr Milwaukee, WI, 47648-8405 USA',
  },
];
